import { Grid, makeStyles, Typography } from "@material-ui/core";
import Select from "react-select";
import * as React from "react";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  selectBox: {
    fontFamily: "VazirFD",
    fontSize: "1.2rem !important",

    "& *": {
      fontFamily: "VazirFD",
      textAlign: "left",
    },
  },
  label: (props) => ({
    fontWeight: "bold",
    "&:after": {
      content: props.required ? '" *"' : "",
      color: theme.palette.error.main,
    },
  }),
}));
const styles = {
  menuList: (base) => ({
    ...base,
    height: "100px",
    direction: "ltr",

    "&::-webkit-scrollbar": {
      width: "14px",
      height: "18px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffffff",
    },
    "&::-webkit-scrollbar-thumb": {
      height: "6px",
      border: "4px solid rgba(0, 0, 0, 0)",
      backgroundClip: "padding-box",
      backgroundColor: "#8898aa",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#525b67",
    },
  }),
  control: (provided, state) => ({
    ...provided,
    border: state.selectProps.native ? "none" : "default",
    boxShadow: state.selectProps.native
      ? "0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%)"
      : "default",
  }),
  noOptionsMessage: (provided, state) => ({
    ...provided,
    marginTop: "30px",
  }),
};

const NewSelect = ({
  name,
  placeholder,
  className,
  label,
  native = false,
  required = false,
  noOptionsMessage = "چیزی یافت نشد",
  loadingMessage = "در حال بارگذاری اطلاعات",
  disabled = false,
  ...props
}) => {
  const classes = useStyles({ native, required });
  return (
    <Grid item container md={12}>
      <Grid item xs={12} md={12}>
        <Typography className={classes.label}>{label}</Typography>
      </Grid>
      <Grid item xs={12} md={12}>
        <Select
          isDisabled={disabled}
          styles={styles}
          name={name}
          className={clsx(classes.selectBox, className && className)}
          placeholder={placeholder}
          native={native}
          noOptionsMessage={() => noOptionsMessage}
          loadingMessage={() => loadingMessage}
          {...props}
        />
      </Grid>
    </Grid>
  );
};

export default NewSelect;
